import React from 'react';
import classNames from 'classnames';
import { Stack, Clickable, Text } from '@moda/om';
import CheckmarkIcon from '@moda/icons/checkmark-16';
import { formatPrice } from '@moda/portal-stanchions';
import { ShippingMethod } from '../../../hooks/useCart/cart.rest';
import { Box } from '../../Box';

import './ShippingMethodOption.scss';

interface ShippingOptionProps {
  option: ShippingMethod;
  selected: boolean;
  onSelect: () => void;
}

export const ShippingMethodOption: React.FC<ShippingOptionProps> = ({
  option,
  onSelect,
  selected
}) => (
  <Clickable
    className="ShippingMethodOption"
    data-test-id={`shipping-method-option--${option.displayName}`}
    type="button"
    onClick={onSelect}
  >
    <Box
      className={classNames('ShippingMethodOption__box', {
        'ShippingMethodOption__box--selected': selected
      })}
    >
      <Stack space={0}>
        <Text className="ShippingMethodOption__shipping-name" treatment="bold1">
          {option.displayName}
        </Text>
        <Text className="ShippingMethodOption__transit-time" treatment="body1">
          {option.transitTime}
        </Text>
      </Stack>

      <Stack space={0}>
        <Text className="ShippingMethodOption__delivery-label" treatment="body2" color="cement">
          Est. Delivery
        </Text>
        <Text className="ShippingMethodOption__delivery-time" treatment="bold1">
          {option.arrivalDate}
        </Text>
      </Stack>

      <Text className="ShippingMethodOption__charges" treatment="h6">
        {option.charges == 0 || option.freeShipping ? (
          <div>Free</div>
        ) : (
          <div>{formatPrice(option.currency, option.charges)}</div>
        )}
        {selected && <CheckmarkIcon />}
      </Text>
    </Box>
  </Clickable>
);
